<template>
  <div>
    <div v-if="itinerary && flight">
      <span>{{ itinerary.depdate }}</span>
    </div>
    <div
      :id="`itemexpander-${itinerary.jsonid}`"
      class="item-main py-2 flight-brick"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand">
      <div class="item-title p-2 mx-2">
        <div>
          <img
            v-if="itinerary.vendor"
            class="vendor-logo-img"
            :src="`https://www.trailfinders.com/graphics/flights/${itinerary.vendor}.gif`" />
        </div>
        <span class="ml-2">FLIGHT {{ flightNo.toUpperCase() }}</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop mr-2">
        <h6>{{ itinerary.cityfrom }} to {{ itinerary.cityto }}</h6>
        <p>with {{ itinerary.suppliername }}</p>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop mr-3">
        <h6>Departing {{ itinerary.deptime }}</h6>
        <p>
          Arriving {{ itinerary.arrtime }}
          <span v-if="itinerary.arrdate && itinerary.arrdate !== itinerary.depdate"
            >({{ itinerary.arrdate }})</span
          >
        </p>
        <div>
          <p v-if="itinerary.vendorloc && bookingInfo.fil !== 'P' && !friendFamily">
            <span class="flight-checkin-active-link pr-1">Airline Ref:</span>
            <span class="flight-checkin-active-link-ref">{{ itinerary.vendorloc }}</span>
          </p>
        </div>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <!-- // END OF Accordion Header -->

    <!-- This will only be displayed on mobile devices -->
    <div v-if="dropdown" class="item-dropdown flight-dropdown">
      <ul class="mobile-dropdown-flight">
        <li v-if="itinerary.cityfrom">
          <h4>Departing from</h4>
          <p>{{ itinerary.cityfrom }}</p>
        </li>
        <li v-if="itinerary.cityto">
          <h4>To</h4>
          <p>{{ itinerary.cityto }}</p>
        </li>
        <li v-if="itinerary.deptime">
          <h4>Departing at</h4>
          <p>{{ itinerary.deptime }}</p>
        </li>
        <li v-if="itinerary.arrtime">
          <h4>Arriving at</h4>
          <p>
            {{ itinerary.arrtime }}
            <span v-if="itinerary.arrdate && itinerary.arrdate !== itinerary.depdate"
              >({{ itinerary.arrdate }})</span
            >
          </p>
        </li>
        <li v-if="itinerary.suppliername">
          <p>with {{ itinerary.suppliername }} in {{ itinerary.baggageclass }}</p>
        </li>
        <li class="py-1">
          <a
            v-if="itinerary.vendorloc && bookingInfo.fil !== 'P'"
            :href="
              itinerary && itinerary.checkininfo && itinerary.checkininfo.link
                ? itinerary.checkininfo.link
                : ''
            "
            target="_blank"
            >Airline Ref:
          </a>
          {{ itinerary.vendorloc }}
        </li>
      </ul>
    </div>

    <!-- // SERVICE REQUEST INFO -->
    <div v-if="dropdown" class="additional-requests-container">
      <div v-if="itinerary.servicerequests.length > 0" class="mt-0 pt-0">
        <ul
          v-for="service of itinerary.servicerequests"
          :key="service.clientId"
          class="additional-requests-list">
          <li v-if="service.name">
            <strong>{{ service.name }}</strong>
          </li>
          <li v-if="service.mealRequested">
            <strong>Meals Requested:</strong> {{ formatCaseSensitive(service.mealRequested) }}
          </li>
          <li v-if="service.membership"><strong>Membership:</strong> {{ service.membership }}</li>
          <li v-if="service.assistanceRequested">
            <strong>Assistance Requested:</strong> {{ service.assistanceRequested }}
          </li>
          <li v-if="service.bassinet === 'R'"><strong>Bassinet:</strong> Requested</li>
        </ul>
      </div>
      <div v-else>
        <p class="pl-3 pb-3 pt-3">No requests were made</p>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    flight: {
      type: Object,
      default: null,
    },
    flightNo: {
      type: String,
      default: null,
    },
    itinerary: {
      type: Object,
      default: null,
    },
    dropdownProp: {
      type: Boolean,
      default: false,
    },
    expandAllProp: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dropdown: null,
    }
  },
  mounted() {
    this.dropdown = this.dropdownProp
  },
  watch: {
    expandAllProp(newVal) {
      if (newVal === true) {
        this.dropdown = true
      } else {
        this.dropdown = false
      }
      return newVal
    },
  },
  computed: {
    ...mapGetters({
      bookingInfo: 'booking/getBookingInfo',
      friendFamily: 'friendFamily/isFriendFamily',
    }),
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown
    },
    formatCaseSensitive(text) {
      text = text.toLowerCase()
      let re = /(\b[a-z](?!\s))/g
      let regexText = text.replace(re, (x) => x.toUpperCase())

      return regexText
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
